module.exports = __webpack_public_path__ + "static/media/steve-wright.c0902027.md";